import cardsData from "@/mocks/cardGridMock.json";
import type { Card } from "@/components/CardGrid/types";
import type { Messages } from "@/i18n/useTranslations";

type HomepageMessageKey = keyof Messages["Homepage"];

type PopularTopicCard = {
  href: string;
  img: string;
  labelKey: HomepageMessageKey;
};

export const getTranslatedPopularTopicCards = (
  t: (key: HomepageMessageKey) => string,
): Card[] =>
  (cardsData as PopularTopicCard[]).map(({ labelKey, img, href }) => ({
    altText: t(labelKey),
    img,
    href,
  }));
